import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
  ActionSheetController,
  ToastController,
  ModalController
} from 'ionic-angular';
import { ClubProvider } from '../../../providers/club/club';
import {ImageEdit} from "../new-post/image-edit/image-edit";


/**
 * Generated class for the CreateClubStandalonePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-create-club-standalone',
  templateUrl: 'create-club-standalone.html',
})
export class CreateClubStandalonePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public actionSheetCtrl: ActionSheetController,
    public clubProvider: ClubProvider,
    public toastCtrl: ToastController,
    private modalCtrl: ModalController ) {
  }

  clubInfos:any = {
    avatar: '',
    name: '',
    description : '',
    city: 'Lyon',
    active: true,
    sponsored: false,
  }

  handleFileSelect(evt){
    var files = evt.target.files;
    var file = files[0];

    this.presentModal(file);
  }


  presentModal(file) {
    const modal = this.modalCtrl.create(ImageEdit, {file: file});
    modal.onDidDismiss(res => {
      if(res?.image) {
        this.clubInfos.avatar = res.image;
      }
    });
    modal.present().then(() => {});
  }
    // End image conversion

    createClub(){
      console.log(this.clubInfos.avatar)
    this.clubProvider.create(this.clubInfos).subscribe((res) => {
      if(res.success){
        let toast = this.toastCtrl.create({
          message: 'Vous avez créé le club '+this.clubInfos.name,
          duration: 3000,
          position: 'top'
        });
        toast.present();
        this.clubProvider.join(res.data.id).subscribe((res) => {
          if(res.success){
            this.viewCtrl.dismiss();
          }
        })
      }
    })
  }

  joinClub(id, name){

  }


  ionViewDidLoad() {
    console.log('ionViewDidLoad CreateClubStandalonePage');
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/employee/create-club-standalone/create-club-standalone.ts